import { render, staticRenderFns } from "./SlotClosureDoctorTable.vue?vue&type=template&id=2825dbf8&scoped=true"
import script from "./SlotClosureDoctorTable.vue?vue&type=script&lang=js"
export * from "./SlotClosureDoctorTable.vue?vue&type=script&lang=js"
import style0 from "./SlotClosureDoctorTable.vue?vue&type=style&index=0&id=2825dbf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825dbf8",
  null
  
)

export default component.exports